import { Col, Descriptions, Row, Table } from 'antd';
import moment from 'moment';
import React from 'react';
import DescripcionPlan from '../../components/DescripcionPlan';

export const Asegurados = ({ asegurados }) => {
  if (!asegurados.list) {
    return null;
  }
  return (
    <Descriptions
      title="Detalle de Asegurado Titular"
      style={{ textAlign: 'left' }}
      bordered
      size="small"
      column={{ md: 2, sm: 1, xs: 1 }}
    >
      <Descriptions.Item label="Nombre" span={2}>
        {asegurados.list[0].nombres}
      </Descriptions.Item>
      <Descriptions.Item label="Cédula">
        {asegurados.list[0].cedula}
      </Descriptions.Item>
      <Descriptions.Item label="Fecha de Nacimiento">
        {moment(asegurados.list[0].fechaNacimiento).format('DD/MM/YYYY')}
      </Descriptions.Item>
      <Descriptions.Item label="Celular">
        {asegurados.list[0].celular}
      </Descriptions.Item>
      <Descriptions.Item label="Correo">
        {asegurados.list[0].correo}
      </Descriptions.Item>
    </Descriptions>
  );
};

export const Vigencia = ({ vigenciaPago, tipo }) => {
  if (!vigenciaPago) {
    return null;
  }
  const columns = [
    {
      title: 'Vigencia',
      dataIndex: 'nombre',
      key: 'nombre',
      colSpan: 2,
      align: 'left',
      render: (text, row, index) => {
        if (index > 0) {
          return text;
        }
        return {
          children: text,
          props: {
            colSpan: 2
          }
        };
      }
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      key: 'valor',
      colSpan: 0,
      render: (value, row, index) => {
        const obj = {
          children: value,
          props: {}
        };
        if (index === 0) {
          obj.props.colSpan = 0;
        }
        return obj;
      }
    }
  ];

  const data = [
    {
      nombre:
        tipo === 'vehiculo'
          ? '* El inicio de la vigencia está sujeto al pago'
          : '* La vigencia será renovada por el mismo periodo recurrentemente, sujeto al pago',
      key: '0',
      valor: ''
    },
    {
      nombre: 'Desde',
      key: '1',
      valor: moment.isMoment(vigenciaPago.desde)
        ? vigenciaPago.desde.format('DD/MM/YYYY')
        : moment(vigenciaPago.desde).format('DD/MM/YYYY')
    },
    {
      nombre: 'Hasta',
      key: '2',
      valor: moment.isMoment(vigenciaPago.hasta)
        ? vigenciaPago.hasta.format('DD/MM/YYYY')
        : moment(vigenciaPago.hasta).format('DD/MM/YYYY')
    },
    {
      nombre: 'Días',
      key: '3',
      valor: vigenciaPago.cantidad_dias
    }
  ];

  return (
    <>
      <Descriptions
        title="Datos de Vigencia"
        style={{ textAlign: 'left', marginTop: 30 }}
      >
        <Descriptions.Item label="">
          <Table
            fixed
            scroll={false}
            style={{ width: '100%' }}
            bordered
            dataSource={data}
            columns={columns}
            pagination={false}
          />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export const Pasajeros = ({ pasajeros }) => {
  if (!pasajeros.list) {
    return null;
  }
  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre'
    },
    {
      title: 'Apellido',
      dataIndex: 'apellido',
      key: 'apellido'
    },
    {
      title: 'Cédula',
      dataIndex: 'cedula',
      key: 'cedula'
    },
    {
      title: 'Fecha Nacimiento',
      dataIndex: 'fechaNacimiento',
      key: 'fechaNacimiento',
      render: (record) => {
        return moment.isMoment(record)
          ? record.format('DD/MM/YYYY')
          : moment(record).format('DD/MM/YYYY');
      }
    }
  ];

  const data = pasajeros.list.map((item, index) => ({
    ...item,
    key: `${index}`
  }));
  return (
    <>
      {pasajeros.list && pasajeros.list.length > 0 && (
        <Descriptions
          title="Detalle de Pasajero/s"
          style={{ textAlign: 'left', marginTop: 30 }}
        >
          <Descriptions.Item label="">
            <Table
              fixed
              scroll={false}
              style={{ width: '100%' }}
              bordered
              dataSource={data}
              columns={columns}
              pagination={false}
            />
          </Descriptions.Item>
        </Descriptions>
      )}
    </>
  );
};

const Contacto = ({ contacto, cuestionario }) => {
  const { tercero } = contacto;
  return (
    <>
      {contacto && (
        <>
          {cuestionario && contacto.respuestas && (
            <>
              <Descriptions
                title="Cuestionario de Salud"
                style={{ textAlign: 'left' }}
                column={{ md: 2, sm: 1, xs: 1 }}
                size="small"
              />
              {Object.keys(cuestionario).map((key) => (
                <Row
                  key={key}
                  justify="start"
                  style={{ marginBottom: 15, textAlign: 'left' }}
                >
                  <Col span={24} align="start">
                    <strong>{`${cuestionario[key]}`}</strong>
                  </Col>
                  <Col span={24} align="start">
                    {contacto.respuestas[key] || 'No'}
                  </Col>
                </Row>
              ))}
            </>
          )}
          <Descriptions
            title="Datos del Asegurado"
            style={{ textAlign: 'left', marginTop: 30 }}
            column={{ md: 2, sm: 1, xs: 1 }}
            bordered
            size="small"
          >
            <Descriptions.Item label="Nombre y Apellido" span={2}>
              {contacto.nombres}
            </Descriptions.Item>
            <Descriptions.Item label="RUC">{contacto.ruc}</Descriptions.Item>
            <Descriptions.Item label="Cédula">
              {contacto.cedula}
            </Descriptions.Item>
            <Descriptions.Item label="Celular">
              {`+595${contacto.celular}`}
            </Descriptions.Item>
            <Descriptions.Item label="Correo">
              {contacto.correo}
            </Descriptions.Item>
            <Descriptions.Item label="Departamento">
              {contacto.departamentoDescripcion}
            </Descriptions.Item>
            <Descriptions.Item label="Ciudad">
              {contacto.distritoDescripcion}
            </Descriptions.Item>
            <Descriptions.Item label="Dirección" span={2}>
              {contacto.domicilio}
            </Descriptions.Item>
            <Descriptions.Item label="Sexo">{contacto.sexo}</Descriptions.Item>
            <Descriptions.Item label="Estado civil">
              {contacto.estadoCivil}
            </Descriptions.Item>
            <Descriptions.Item label="Fecha nacimiento">
              {contacto.fechaNacimiento &&
                contacto.fechaNacimiento.format('DD/MM/YYYY')}
            </Descriptions.Item>

            <Descriptions.Item label="Nacionalidad">
              {contacto.nacionalidad}
            </Descriptions.Item>
            <Descriptions.Item label="Lugar nacimiento">
              {contacto.lugarNacimiento}
            </Descriptions.Item>

            {/* {listaMetodoPago.find((item) => item.id === contacto.metodoPago)
              ?.codigo === "tarjeta" && (
              <>
                <Descriptions.Item label="Número tarjeta" span={2}>
                  {contacto.numeroTarjeta}
                </Descriptions.Item>
                <Descriptions.Item label="Titular tarjeta">
                  {contacto.titularTarjeta}
                </Descriptions.Item>
                <Descriptions.Item label="Vencimiento tarjeta">
                  {contacto.vencimientoTarjeta}
                </Descriptions.Item>
              </>
            )}
            {["cadebito", "ccdebito"].includes(
              listaMetodoPago.find((item) => item.id === contacto.metodoPago)
                ?.codigo
            ) && (
              <>
                <Descriptions.Item label="Número de cuenta" span={2}>
                  {contacto.numeroCuenta}
                </Descriptions.Item>
              </>
            )} */}
          </Descriptions>
          {tercero.ruc && (
            <Descriptions
              title="Datos de Facturación"
              style={{ textAlign: 'left', marginTop: 30 }}
              column={{ md: 2, sm: 1, xs: 1 }}
              bordered
              size="small"
            >
              <Descriptions.Item label="Razón Social" span={2}>
                {tercero.nombres}
              </Descriptions.Item>
              <Descriptions.Item label="CI / RUC">
                {tercero.ruc}
              </Descriptions.Item>
              <Descriptions.Item label="Correo">
                {tercero.correo}
              </Descriptions.Item>
              <Descriptions.Item label="Dirección" span={2}>
                {tercero.domicilio}
              </Descriptions.Item>
              <Descriptions.Item label="Celular">
                {tercero.celular && `+595${tercero.celular}`}
              </Descriptions.Item>
              <Descriptions.Item label="Teléfono (Línea Baja)">
                {tercero.telefono}
              </Descriptions.Item>
            </Descriptions>
          )}
        </>
      )}
    </>
  );
};

const FormaPago = ({ contacto, aseguradora, listaMetodoPago, pagos }) => {
  return (
    <Descriptions
      title="Compañía y Forma de pago"
      style={{ textAlign: 'left', paddingTop: 40 }}
      bordered
      size="small"
      column={{ md: 2, sm: 1, xs: 1 }}
    >
      <Descriptions.Item label="Aseguradora">
        {aseguradora.descripcion ? aseguradora.descripcion : 'N/A'}
      </Descriptions.Item>
      <Descriptions.Item label="Medio de pago">
        {contacto.metodoPago
          ? listaMetodoPago.find((item) => item.id === contacto.metodoPago)
              .descripcion
          : ''}
      </Descriptions.Item>
      <Descriptions.Item label="Frecuencia de pago">
        {pagos?.frecuencia?.descripcion}
      </Descriptions.Item>
      <Descriptions.Item label="Cuotas" span={2}>
        {pagos?.cantidad_pagos}
      </Descriptions.Item>
    </Descriptions>
  );
};

const ContacoEmergencia = ({ emergencia }) => {
  return (
    <Descriptions
      title="Contacto de Emergencia"
      style={{ textAlign: 'left', paddingTop: 40 }}
      bordered
      size="small"
      column={{ md: 2, sm: 1, xs: 1 }}
    >
      <Descriptions.Item label="Nombre">{emergencia.nombres}</Descriptions.Item>
      <Descriptions.Item label="Celular">
        {emergencia.celular}
      </Descriptions.Item>
      <Descriptions.Item label="Correo">{emergencia.correo}</Descriptions.Item>
      <Descriptions.Item label="Consideraciones" span={2}>
        {emergencia.consideraciones}
      </Descriptions.Item>
    </Descriptions>
  );
};

const Descripciones = ({
  plan,
  listaMetodoPago,
  listaVigenciaPago,
  asegurados,
  pasajeros,
  emergencia,
  contacto,
  cuestionario,
  aseguradora,
  listaModalidadPago,
  vigencia,
  pagos
}) => {
  return (
    <div style={{ maxWidth: '1000px', margin: 'auto' }}>
      <Asegurados
        {...{
          asegurados
        }}
      />
      <Pasajeros {...{ pasajeros }} />
      <ContacoEmergencia {...{ emergencia }} />
      <DescripcionPlan {...{ plan }} />
      <Contacto {...{ contacto, listaMetodoPago, cuestionario, plan }} />
      <Vigencia {...{ listaVigenciaPago, vigenciaPago: vigencia }} />
      <FormaPago
        {...{
          contacto,
          aseguradora,
          listaMetodoPago,
          listaModalidadPago,
          pagos
        }}
      />
    </div>
  );
};

export default Descripciones;
